import { ReactElement, SVGProps } from 'react';

import { WalletType, WalletTypeExtended } from '@/context/types';
import { cn } from '@/utils/cn';

import { Icons } from './icons';

interface ConnectWalletItemProps {
  isInstalled: boolean;
  isButtonBlocked: boolean;
  label: string;
  logo: ReactElement<SVGProps<SVGSVGElement>>;
  downloadLink: string;
  walletType: WalletType | WalletTypeExtended;
  itemClass?: string;
  itemTitleClass?: string;
  connect: (walletType: WalletType | WalletTypeExtended) => Promise<void>;
}

const ConnectWalletItem: React.FC<ConnectWalletItemProps> = ({
  isInstalled,
  isButtonBlocked,
  label,
  logo,
  downloadLink,
  walletType,
  itemClass = '',
  itemTitleClass = '',
  connect,
}) => {
  const handleClick = () => {
    // prevent multiple clicks when button is blocked
    if (isButtonBlocked) {
      return;
    }

    if (isInstalled) {
      connect(walletType);
    } else {
      window.open(downloadLink, '_blank');
    }
  };

  return (
    <button
      type='button'
      className={cn(
        'cursor-pointer w-full text-text-primary flex items-center justify-between transition-colors duration-200',
        itemClass || 'py-3 px-6 border-[1.6px] border-border-secondary rounded-2xl hover:border-text-primary/50',
        isButtonBlocked && 'opacity-80 cursor-not-allowed',
      )}
      onClick={handleClick}
      disabled={isButtonBlocked}
    >
      <span className={cn('flex items-center gap-x-3 font-medium text-2xl leading-7', itemTitleClass || 'text-2xl leading-7')}>
        {logo} {label}
      </span>
      {isInstalled ? (
        <Icons.externalLink className='text-text-secondary' />
      ) : (
        <span className='inline-flex items-center justify-center px-2 py-1.5 text-sm leading-4 font-medium bg-button-secondary ring-1 ring-border-secondary text-text-primary rounded-md hover:bg-button-secondary-hover transition-colors'>
          Get
        </span>
      )}
    </button>
  );
};

export default ConnectWalletItem;
